
// const flvConfig = {
//   configs: {
//     background: '', // 背景
//     objectFit: 'fill', // contain等宽 cover包裹 fill填充
//     player: {
//       isLive: true,
//       enableStashBuffer: false,
//       autoCleanupSourceBuffer: false,
//       autoCleanupMaxBackwardDuration: 4,
//       autoCleanupMinBackwardDuration: 1,
//       fixAudioTimestampGap: false
//     },
//     lostTime: 6.0,
//     catchNew: 3.0,
//     playbackRate: 1.2
//   },
//   maxtime: 2599803200000,
//   urls: []
// }
export const configs = {
  background: './static/video/images/bg.jpg', // 背景
  objectFit: 'fill', // contain等宽 cover包裹 fill填充
  player: {
    isLive: true,
    enableStashBuffer: false,
    autoCleanupSourceBuffer: false,
    autoCleanupMaxBackwardDuration: 4,
    autoCleanupMinBackwardDuration: 1,
    fixAudioTimestampGap: false
  },
  lostTime: 4.0,
  realtime: 3.0,
  smoothtimemax: 60.0,
  smoothtimemin: 4.0,
  retainvideo: true
}
export const maxtime = 2599803200000
export const urls = []




//////////////////
// WEBPACK FOOTER
// ./static/video/config.js
// module id = null
// module chunks = 